import { fetchAddressRequest } from 'actions'
import SearchBox from 'components/search-box'
import { useEffect } from 'react'
import { FaAngleDown } from 'react-icons/fa6'
import { IoIosCopy } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RootState } from 'reducers'
import { AppDispatch } from 'store'
import Transactions from './Transactions'
import { VoteOverview, GeneralOverview, StakeOverview } from './OverviewCard'
import { IAccount } from 'interfaces/account.interface'

const getAccountOverview = (address: IAccount) => {
	if (address.data.parsed) {
		switch (address.data.parsed.program) {
			case 'vote':
				return {
					title: 'Vote Address',
					component: <VoteOverview address={address} />
				}
			case 'stake':
				return {
					title: 'Stake Address',
					component: <StakeOverview address={address} />
				}
			default:
				return {
					title: 'Address',
					component: <GeneralOverview address={address} />
				}
		}
	}

	return {
		title: 'Address',
		component: <GeneralOverview address={address} />
	}
}

const Address = () => {
	const { address: queryAddress } = useParams()

	const dispatch = useDispatch<AppDispatch>()
	const { address } = useSelector((state: RootState) => state.address)

	useEffect(() => {
		dispatch(fetchAddressRequest(queryAddress))
	}, [dispatch, queryAddress])

	if (!address) {
		return null
	}

	return (
		<div className="relative">
			{/* Card widget */}
			<div className="header-back-gradient">
				<div className="container py-6">
					<div className="w-full px-2.5 md:px-3 lg:px-5">
						<div className="flex w-full items-center ">
							<div className="w-full justify-between md:flex md:gap-6 md:py-6">
								<div className="mb-4 md:mb-0">
									<p className="text-header relative mb-3 text-white">{getAccountOverview(address).title}</p>
									<div className="flex items-center gap-[2px]">
										<div className="truncateWrapper">
											<span className="text-large mr-1 truncate text-white">{address.pubkey}</span>
										</div>
										<button className="text-large text-green-600">
											<IoIosCopy />
										</button>
									</div>
								</div>
								<SearchBox
									className="sm:min-w-[480px] xl:min-w-[650px]"
									placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
								/>
							</div>
						</div>
						<div className="mt-3 flex w-full text-center md:mt-1">
							<div className="ml-auto mr-auto flex gap-4 md:mr-0">
								<button className="btn btn-gray text-xsmall flex items-center !font-semibold">
									Buy{' '}
									<span className="ml-[1px] text-xs">
										<FaAngleDown />
									</span>
								</button>
								<button className="btn btn-gray text-xsmall flex items-center !font-semibold">
									Exchange{' '}
									<span className="ml-[1px] text-xs">
										<FaAngleDown />
									</span>
								</button>
								<button className="btn btn-gray text-xsmall flex items-center !font-semibold">
									Play{' '}
									<span className="ml-[1px] text-xs">
										<FaAngleDown />
									</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Address info */}
			<div className="container">
				{getAccountOverview(address).component}
				{/* Transactions */}
				<Transactions pubKey={address.pubkey} transactions={address.transactions} />
			</div>
		</div>
	)
}

export default Address
